const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/measurements/$bodyMetricId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/measurements/$bodyMetricId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { BodyMetricNotFoundError } from '@/features/body-measurements/domain/errors';
import { defaultMeasurementDateRange } from '@/features/body-measurements/lib/date-range';
import { getMeasurementSeriesQuery } from '@/features/body-measurements/lib/get-measurement-series.query';
import { listBodyMetricsQuery } from '@/features/body-measurements/lib/list-body-metrics.query';
import { MeasurementsSkeleton } from '@/features/body-measurements/ui/measurements-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/measurements/$bodyMetricId')({
  beforeLoad: ({
    context,
    params
  }) => {
    const validated = context.deps.validators.bodyMetricIdValidator.validate(params.bodyMetricId);
    if (!validated.ok) {
      throw redirect({
        to: '/tracking/measurements'
      });
    }
    return {
      bodyMetricId: validated.data
    };
  },
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        bodyMeasurementsController: context.deps.controllers.bodyMeasurementsController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureQueryData(listBodyMetricsQuery(deps)), context.queryClient.ensureQueryData(getMeasurementSeriesQuery(deps, context.bodyMetricId, defaultMeasurementDateRange()))]);
    } catch (error) {
      if (error instanceof BodyMetricNotFoundError) {
        throw redirect({
          to: '/tracking/measurements',
          replace: true
        });
      }
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: MeasurementsSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});